export enum HackerReviewerStatus {
  HACKER_REVIEWER_STATUS_NONE = 'None',
  HACKER_REVIEWER_STATUS_POOR = 'Poor',
  HACKER_REVIEWER_STATUS_WEAK = 'Weak',
  HACKER_REVIEWER_STATUS_AVERAGE = 'Average',
  HACKER_REVIEWER_STATUS_STRONG = 'Strong',
  HACKER_REVIEWER_STATUS_OUTSTANDING = 'Outstanding',
  HACKER_REVIEWER_STATUS_WHITELIST = 'Whitelist',
}
export default HackerReviewerStatus;
